// Static, easy-to-edit business content. Source of truth: supplied EI Battery brief
// + manufacturer documents supplied by the business owner (Dyness Stack100 Pro datasheet,
// user manual, AU warranty, module MSDS; Dyness Cygni Series datasheet). Specs quoted from
// those documents only. Product images extracted from the official manufacturer datasheets.
import posterCygniFront from "@/assets/brand/products/poster-cygni-front.webp";
import cygniBuildKit from "@/assets/brand/products/cygni-build-kit.png";
import posterCygniAngle from "@/assets/brand/products/poster-cygni-angle.webp";
import posterPowerboxFront from "@/assets/brand/products/poster-powerbox-front.webp";
import posterPowerboxAngle from "@/assets/brand/products/poster-powerbox-angle.webp";
import kitStackThreePhase from "@/assets/brand/products/kit-stack-three-phase.webp";
import posterBdu from "@/assets/brand/products/poster-bdu-stack.webp";
import stack15Angle from "@/assets/brand/products/stack100-pro-15kwh-angle.webp";
import stack15Front from "@/assets/brand/products/stack100-pro-15kwh-front.webp";
import bduFrontPoster from "@/assets/brand/products/bdu-front-poster.webp";
import bduRearPoster from "@/assets/brand/products/bdu-rear-poster.webp";
import invSolinteg5kBlue from "@/assets/brand/products/inverter-solinteg-5k-blue.png";
import invSolintegMhtFront from "@/assets/brand/products/solinteg-mht-front.png";
import invSolintegMhtAngle from "@/assets/brand/products/solinteg-mht-angle.png";
import invSolintegMhtConnections from "@/assets/brand/products/solinteg-mht-connections.png";
import invSolinteg8kBlue from "@/assets/brand/products/inverter-solinteg-8k-blue.png";
import invSolis10kBlue from "@/assets/brand/products/inverter-solis-10k-blue.png";
import invSolisHv3pFront from "@/assets/brand/products/solis-hv-3p-front.png";
import invSolisHv3pSide from "@/assets/brand/products/solis-hv-3p-side.png";
import invSolisHv3pRear from "@/assets/brand/products/solis-hv-3p-rear.png";
import invSolisHv3pConnections from "@/assets/brand/products/solis-hv-3p-connections.png";
import invSolis3pFront from "@/assets/brand/products/solis-s6-eh3p-front.png";
import invSolis3pAngle from "@/assets/brand/products/solis-s6-eh3p-angle.png";
import invSolis3pSide from "@/assets/brand/products/solis-s6-eh3p-side.png";
import invSolis3pConnections from "@/assets/brand/products/solis-s6-eh3p-connections.png";
import invSolis15kBlue from "@/assets/brand/products/inverter-solis-15k-blue.png";
import invSolisPlusFront from "@/assets/brand/products/solis-s6-eh1p-plus-front.png";
import invSolisPlusAngle from "@/assets/brand/products/solis-s6-eh1p-plus-angle.png";
import invSolisPlusConnections from "@/assets/brand/products/solis-s6-eh1p-plus-connections.png";
import invSolisPlusSide from "@/assets/brand/products/solis-s6-eh1p-plus-side.png";
import invSolis10kFront from "@/assets/brand/products/solis-s6-eh1p10k-front.png";
import invSolis10kAngle from "@/assets/brand/products/solis-s6-eh1p10k-angle.png";
import invSolis10kSide from "@/assets/brand/products/solis-s6-eh1p10k-side.png";
import invSolis10kConnections from "@/assets/brand/products/solis-s6-eh1p10k-connections.png";
import panelRisen630Blue from "@/assets/brand/products/panel-risen-630-blue.png";
import panelRisen475Blue from "@/assets/brand/products/panel-risen-475-blue.png";
import powerboxG2Cutaway from "@/assets/brand/products/1-powerbox-g2.png";
import cygniStackOpen from "@/assets/brand/products/2-cygni-stack.png";
import cygniTopAngle from "@/assets/brand/products/3-cygni-top.png";
import cygniBasePlate from "@/assets/brand/products/4-cygni-base-plate.png";
import cygniWallPlate from "@/assets/brand/products/5-cygni-wall-plate.png";
import cygniBaseTray from "@/assets/brand/products/6-cygni-base-tray.png";
import stackModulesPair from "@/assets/brand/products/7-stack100-modules-pair.png";
import stackModuleSingle from "@/assets/brand/products/8-stack100-module.png";
import cygniInverterPhoto from "@/assets/brand/products/9-cygni-inverter.png";
import cygniModulePair from "@/assets/brand/products/10-cygni-module-pair.png";
import cygniModuleStack from "@/assets/brand/products/11-cygni-module-stack.png";
import solis15kHvPhoto from "@/assets/brand/products/12-solis-15k-hv.png";
import stack100RangePhoto from "@/assets/brand/products/13-stack100-range.png";
import solis10kHvPhoto from "@/assets/brand/products/14-solis-10k-hv.png";
const SOLIS_HV_3P_DOCS = [
  { label: "Solis S6-EH3P(5–10)K-H-AU installation manual (V1.0, Nov 2024)", file: "/docs/solis-s6-eh3p-5-10k-h-au-manual.pdf", type: "User manual" },
];
import powerboxG2Exploded from "@/assets/brand/products/15-powerbox-g2-exploded.png";

export const COMPANY = {
  name: "EI Battery Solutions",
  tagline: "Wholesale battery supply for the Australian trade",
  phone: "0414 662 445",
  phoneHref: "tel:+61414662445",
  email: "admin@eibattery.com.au",
  address: "Kew VIC 3101",
  abn: "23 943 384 114",
  serviceArea: "Australia-wide",
  ceo: "Craig Jobson",
  headOfSales: "Charles Gardiner",
};

// Manufacturer recognition — belongs to Dyness (the battery maker), not EI Battery.
export const MANUFACTURER = {
  name: "Dyness",
  awards:
    "EUPD Research TOP Brand PV Storage — awarded to Dyness across 10+ international markets from 2022 to 2026.",
  note: "Recognition awarded to the manufacturer, Dyness. EI Battery Solutions is a wholesale supplier of Dyness equipment.",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Products", to: "/products" },
  { label: "Kits & systems", to: "/kits" },
  { label: "Guides", to: "/guides" },
  { label: "Delivery & support", to: "/delivery-and-support" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const PRODUCTS = [
  {
    slug: "cygni-bat-38-module",
    component: true,
    name: "Dyness Cygni BAT-3.8 battery module",
    category: "Battery module",
    manufacturer: "Dyness Cygni BAT-3.8",
    image: cygniModulePair,
    homeImage: cygniModulePair,
    imageAlt: "Dyness Cygni BAT-3.8 battery module",
    images: [cygniModulePair, cygniModuleStack],
    priceLabel: "$870",
    priceUnit: "(per module)",
    priceNote: "Catalogue price per module — + GST, wholesale ex GST. Freight charged additionally where delivery is required.",
    hasPublicPrice: true,
    summary: "The 3.84 kWh LiFePO4 battery module used in the Dyness Cygni all-in-one system.",
    positioning:
      "An individual Cygni battery module, listed separately so module counts can be itemised on your quotation. Supplied items and quantities are confirmed in your accepted quotation.",
    highlights: [
      "3.84 kWh nominal LiFePO4 battery module",
      "Stacks within the Dyness Cygni all-in-one system",
      "Supplied wholesale to registered electrical contractors, builders and property developers",
    ],
    specs: [
      { label: "Battery chemistry", value: "Lithium iron phosphate (LiFePO4)" },
      { label: "Nominal energy", value: "3.84 kWh per module" },
      { label: "System", value: "Dyness Cygni series" },
    ],
    certifications: [],
    documents: [],
    specNote: "Specifications from the Dyness Cygni datasheet and the EI Battery catalogue (October 2026).",
  },
  {
    slug: "cygni-inverter",
    component: true,
    name: "Dyness Cygni 10.0HS inverter",
    category: "Hybrid inverter",
    manufacturer: "Dyness Cygni 10.0HS",
    image: cygniInverterPhoto,
    homeImage: cygniInverterPhoto,
    imageAlt: "Dyness Cygni 10.0HS hybrid inverter",
    images: [cygniInverterPhoto],
    priceLabel: "$1,430",
    priceUnit: "(per inverter)",
    priceNote: "Catalogue price per unit — + GST, wholesale ex GST. Freight charged additionally where delivery is required.",
    hasPublicPrice: true,
    summary: "The 10 kW hybrid inverter integrated into the Dyness Cygni all-in-one system.",
    positioning:
      "The Cygni hybrid inverter, listed separately so it can be itemised on your quotation. Supplied items and quantities are confirmed in your accepted quotation.",
    highlights: [
      "10 kW single-phase hybrid inverter",
      "Designed for the Dyness Cygni battery stack",
      "Supplied wholesale to registered electrical contractors, builders and property developers",
    ],
    specs: [
      { label: "Rated AC power", value: "10 kW" },
      { label: "Phase", value: "Single-phase" },
      { label: "Battery pairing", value: "Dyness Cygni modules" },
    ],
    certifications: [],
    documents: [],
    specNote: "Specifications from the Dyness Cygni datasheet and the EI Battery catalogue (October 2026).",
  },
  {
    slug: "cygni-base",
    component: true,
    name: "Dyness Cygni base",
    category: "Mounting accessory",
    manufacturer: "Dyness Cygni Series",
    image: cygniBaseTray,
    homeImage: cygniBaseTray,
    imageAlt: "Dyness Cygni base",
    images: [cygniBaseTray, cygniBasePlate],
    priceLabel: "$95",
    priceUnit: "(per base)",
    priceNote: "Catalogue price per unit — + GST, wholesale ex GST. Freight charged additionally where delivery is required.",
    hasPublicPrice: true,
    summary: "The base that the Dyness Cygni stack is built on.",
    positioning:
      "The Cygni base, listed separately so it can be itemised on your quotation. Supplied items and quantities are confirmed in your accepted quotation.",
    highlights: [
      "Required per Cygni stack",
      "Supplied wholesale to registered electrical contractors, builders and property developers",
    ],
    specs: [{ label: "System", value: "Dyness Cygni series" }],
    certifications: [],
    documents: [],
    specNote: "Listed per the EI Battery catalogue (October 2026).",
  },
  {
    slug: "stack100-pro-module",
    component: true,
    name: "Dyness Stack100 Pro battery module",
    category: "Battery module",
    manufacturer: "Dyness S51100 Pro",
    image: stackModulesPair,
    homeImage: stackModulesPair,
    imageAlt: "Dyness Stack100 Pro S51100 Pro 5.12 kWh battery module",
    images: [stackModulesPair, stackModuleSingle, stack100RangePhoto],
    priceLabel: "$1,080",
    priceUnit: "(per 5.12 kWh module)",
    priceNote: "Catalogue price per module — + GST, wholesale ex GST. Freight charged additionally where delivery is required.",
    hasPublicPrice: true,
    summary: "The 5.12 kWh LiFePO4 module that builds a Dyness Stack100 Pro cluster.",
    positioning:
      "An individual Stack100 Pro module, listed separately so module counts can be itemised on your quotation. Supplied items and quantities are confirmed in your accepted quotation.",
    highlights: [
      "5.12 kWh nominal (4.864 kWh usable) LiFePO4 module",
      "Builds Stack100 Pro clusters with the SBDU100 Pro controller and base",
      "Supplied wholesale to registered electrical contractors, builders and property developers",
    ],
    specs: [
      { label: "Battery chemistry", value: "Lithium iron phosphate (LiFePO4)" },
      { label: "Nominal energy", value: "5.12 kWh per module" },
      { label: "Usable energy", value: "4.864 kWh per module" },
      { label: "Model reference", value: "Module S51100 Pro" },
    ],
    certifications: [],
    documents: [],
    specNote: "Specifications from the Dyness Stack100 Pro datasheet (April 2026) and the EI Battery catalogue (October 2026).",
  },
  {
    slug: "cygni-base-wall-plate",
    draft: true,
    name: "Dyness Cygni Base Plate & Wall Plate",
    category: "Mounting accessory",
    manufacturer: "Dyness Cygni Series",
    image: cygniBasePlate,
    homeImage: cygniBasePlate,
    imageAlt: "EI Battery — Dyness Cygni base plate and wall plate mounting set",
    images: [cygniBasePlate, cygniWallPlate],
    hasPublicPrice: false,
    summary:
      "The Cygni base plate and wall plate, supplied together as one mounting set.",
    positioning:
      "Draft listing. Supplied as a single combined item; details are confirmed at quotation.",
    highlights: [],
    specs: [],
    certifications: [],
    documents: [],
  },
  {
    slug: "cygni-all-in-one",
    name: "Cygni All in One",
    batteryId: "cygni-module",
    category: "Battery & inverter combination",
    manufacturer: "Dyness Cygni Series",
    image: cygniBuildKit,
    homeImage: cygniBuildKit,
    imageAlt: "EI Battery — Dyness Cygni 10.0HS-M4 all-in-one battery and hybrid inverter package",
    nameNote: "15.20 kWh / 10 kW hybrid inverter",
    video: { src: "/media/video-3.mp4", poster: "/media/video-3-poster.jpg" },
    images: [cygniBuildKit, posterCygniFront, posterCygniAngle, cygniStackOpen, cygniTopAngle],
    video: { src: "/media/product-cygni.mp4" },
    originalPrice: "$5,925",
    priceLabel: "$4,950",
    priceNote: "Cygni 10.0HS-M4 all-in-one kit (10 kW hybrid inverter + 15.36 kWh) launch price (was $5,925) — + GST, wholesale. Freight charged additionally where delivery is required.",
    hasPublicPrice: true,
    summary:
      "A combined battery and hybrid inverter package with 11 international awards. Slimline and a breeze to install.",
    positioning:
      "An all-in-one residential energy system supplied as a battery and hybrid inverter combination. The exact model and configuration supplied under this package are confirmed at quotation.",
    kit: {
      note: "Supplied as a complete kit — no separate inverter required (the hybrid inverter is built in).",
      items: [
        "Dyness Cygni Hybrid — battery with built-in hybrid inverter",
      ],
      installer:
        "Roof mounting, PV/AC cable, isolation & protection, earthing, metering/CT and commissioning are sized and supplied by your installer for the site.",
    },
    packNote:
      "Indicative equipment price, supply only. Final pricing is confirmed on your trade quote. EI Battery Solutions supplies equipment only to licensed contractors and does not install.",
    packs: [
      {
        name: "15 kWh Battery + 6.3 kW Solar Pack",
        price: "$6,620",
        items: [
          "Dyness Cygni 15 kWh battery + 10 kW hybrid inverter (battery packs × 4 + base)",
          "Risen 630 W solar panels × 10 (6.3 kW)",
        ],
      },
      {
        name: "30 kWh Battery + 13.2 kW Solar Pack",
        price: "$11,870",
        items: [
          "Dyness Cygni 31 kWh battery + 10 kW hybrid inverter (battery packs × 8 + base)",
          "Risen 630 W solar panels × 21 (13.2 kW)",
        ],
      },
    ],
    highlights: [
      "Battery and hybrid inverter supplied as one wholesale package",
      "Scalable, modular energy for residential and light-commercial applications",
      "Supply-only — your team completes design, installation and commissioning",
    ],
    specs: [
      { label: "Type", value: "All-in-one residential energy system (battery + hybrid inverter)" },
      { label: "Battery chemistry", value: "Lithium iron phosphate (LiFePO4)" },
      { label: "Inverter output options", value: "8 kW / 10 kW" },
      { label: "Scalable usable energy", value: "7.30 – 43.77 kWh (modular)" },
      { label: "Nominal battery voltage", value: "192 – 384 V" },
      { label: "Ingress protection", value: "IP66" },
      { label: "Communications", value: "RS485, Wi-Fi, Bluetooth" },
      { label: "Operating temperature", value: "0 – 50 °C" },
      { label: "Safety", value: "Built-in aerosol fire extinguisher" },
      { label: "Mounting", value: "Wall-mounted or floor-standing" },
    ],
    certifications: [
      "AS/NZS 4777.2:2020", "IEC 62619:2022", "IEC 62109-1/2", "IEC 62040",
      "UN38.3", "EN 62920:2017/A1:2021", "IEC/EN 61000-6-1/3",
    ],
    documents: [
      { label: "Dyness Cygni datasheet (Oct 2025)", file: "/docs/dyness-cygni-datasheet-2025-10.pdf", type: "Datasheet" },
      { label: "Dyness Cygni user manual (V3.0, Jul 2026)", file: "/docs/dyness-cygni-usermanual-v3-0-2026-07.pdf", type: "User manual" },
      { label: "Dyness Cygni warranty (V2, 2025)", file: "/docs/dyness-cygni-warranty-v2-2025.pdf", type: "Warranty" },
      { label: "Cygni BAT-3.8 safety data sheet (MSDS, Dec 2024)", file: "/docs/dyness-cygni-bat3-8-msds-2024-12.pdf", type: "MSDS" },
      { label: "Cygni BAT-3.8 UN38.3 test report (Jun 2024)", file: "/docs/dyness-cygni-bat3-8-un38-3-2024-06.pdf", type: "Compliance" },
    ],
    warranty:
      "Product-specific warranty terms are confirmed with your quote. Contact our team for warranty terms and contractor support.",
    specNote:
      "Specifications are quoted from the Dyness Cygni Series datasheet (v20251020). Cygni is a series; the exact model and configuration supplied under the Cygni All in One package are confirmed at quotation.",
  },
  {
    slug: "power-stack-pro-100",
    name: "Stack100 Pro",
    batteryId: "stack-module",
    category: "Battery system",
    manufacturer: "Dyness Stack100 Pro",
    image: stack15Angle,
    homeImage: stack15Angle,
    imageAlt: "EI Battery — Dyness Stack100 Pro 15.36 kWh modular stacked battery system",
    images: [stack15Angle, stack15Front],
    video: { src: "/media/product-stack.mp4" },
    guideVideo: {
      src: "/media/stack100-installation-guide.mp4",
      label: "Installation guide",
      title: "Dyness Stack100 Pro installation guide",
      note: "Manufacturer installation walkthrough supplied by Dyness. Installation is carried out by your licensed electrical contractor.",
    },
    priceLabel: "$3,580",
    priceUnit: "(15.36 kWh bundle — 3× 5.12 kWh modules + BDU + base)",
    priceNote: "STACK100 Pro 15.36 kWh bundle — 3× 5.12 kWh modules + BDU + base, + GST wholesale. Inverter and panels quoted separately or as a system pack below. Freight charged additionally where delivery is required.",
    hasPublicPrice: true,
    summary:
      "A stackable, high-voltage battery system for contractors specifying scalable storage across residential and commercial applications.",
    positioning:
      "A modular, stackable battery system built from LiFePO4 modules. Final configuration and pricing are confirmed at quotation.",
    kit: {
      note: "Supplied items and quantities are listed individually in your accepted quotation. Battery module count, BDU and base are confirmed for the selected configuration. Inverters, solar panels and accessories are included only when individually listed and priced in that quotation. Installation and commissioning are arranged by the purchaser through appropriately licensed personnel.",
      items: [
        "Dyness STACK100 Pro battery modules (5.12 kWh) × 3",
        "Dyness BDU (battery disconnect unit)",
        "Stack base",
      ],
      installer:
        "Roof mounting, PV/AC cable, isolation & protection, earthing, metering/CT and commissioning are sized and supplied by your installer for the site.",
    },
    packNote:
      "Indicative equipment price, supply only. Final pricing is confirmed on your trade quote. EI Battery Solutions supplies equipment only to licensed contractors and does not install.",
    packs: [
      {
        group: "Single phase",
        name: "15 kW Battery + 6.3 kW Solar Pack",
        price: "$6,265",
        items: [
          "5 kW single-phase hybrid inverter × 1",
          "Dyness Stack100 Pro batteries (5.12 kWh) × 3 (15.36 kWh)",
          "Dyness BDU × 1",
          "Risen 630 W solar panels × 10 (6.3 kW)",
        ],
      },
      {
        group: "Single phase",
        name: "30 kW Battery + 13.2 kW Solar Pack",
        price: "$11,870",
        items: [
          "8 kW single-phase hybrid inverter × 1",
          "Dyness Stack100 Pro batteries (5.12 kWh) × 6 (30.72 kWh)",
          "Dyness BDU × 1",
          "Risen 630 W solar panels × 21 (13.2 kW)",
        ],
      },
      {
        group: "Three phase",
        image: kitStackThreePhase,
        name: "20 kW Battery + 10 kW Solar Pack",
        price: "$9,365",
        items: [
          "10 kW Solis three-phase hybrid inverter × 1",
          "Dyness Stack100 Pro batteries (5.12 kWh) × 4 (20.48 kWh)",
          "Dyness BDU × 1",
          "Risen 630 W solar panels × 16 (10 kW)",
        ],
      },
      {
        group: "Three phase",
        image: kitStackThreePhase,
        name: "30 kW Battery + 13.2 kW Solar Pack",
        price: "$13,010",
        items: [
          "15 kW Solis three-phase hybrid inverter × 1",
          "Dyness Stack100 Pro batteries (5.12 kWh) × 6 (30.72 kWh)",
          "Dyness BDU × 1",
          "Risen 630 W solar panels × 21 (13.2 kW)",
        ],
      },
    ],
    highlights: [
      "Modular, stackable design — scale from 3 to 15 battery modules",
      "High-voltage LiFePO4 chemistry with natural cooling",
      "Specified by your team for the end application",
    ],
    specs: [
      { label: "Battery chemistry", value: "Lithium iron phosphate (LiFePO4)" },
      { label: "Battery module (S51100 Pro)", value: "5.12 kWh · 51.2 V · 100 Ah" },
      { label: "Scalable configuration", value: "3 – 15 modules (Stack100 Pro-3S to -15S)" },
      { label: "Usable energy (per stack)", value: "15.36 – 76.8 kWh" },
      { label: "Expandable", value: "Up to 12 clusters in parallel (to 921 kWh)" },
      { label: "Rated DC power", value: "7.68 – 38.4 kW" },
      { label: "Max charge / discharge power", value: "15.36 – 76.8 kW" },
      { label: "Operating voltage", value: "136.8 – 864 V (per configuration)" },
      { label: "Depth of discharge", value: "100%" },
      { label: "Temperature range", value: "−20 °C to 50 °C (charge & discharge)" },
      { label: "Ingress protection", value: "IP66" },
      { label: "Communications", value: "CAN / RS485, built-in Wi-Fi, app OTA" },
      { label: "Cooling", value: "Natural cooling" },
      { label: "Module dimensions / weight", value: "657 × 460 × 169 mm · 55 kg" },
      { label: "Cycle life (datasheet)", value: "≥ 8,000 cycles (100% DOD, 0.2C, 25 °C, BOL)" },
    ],
    certifications: [
      "IEC 62619", "IEC 63056", "IEC 62477", "IEC 62040", "UN38.3", "CE-EMC", "CE-RED",
    ],
    documents: [
      { label: "Dyness Stack100 Pro datasheet (Apr 2026)", file: "/docs/dyness-stack100-pro-datasheet-2026-04.pdf", type: "Datasheet" },
      { label: "Dyness Stack100 Pro user manual (AU)", file: "/docs/dyness-stack100-pro-usermanual-au.pdf", type: "User manual" },
      { label: "Dyness Stack100 Pro warranty (AU, Mar 2026)", file: "/docs/dyness-stack100-pro-warranty-au-2026-03.pdf", type: "Warranty" },
      { label: "Module S51100 Pro safety data sheet (MSDS, Aug 2025)", file: "/docs/dyness-stack100-pro-s51100-pro-msds-2025-08.pdf", type: "MSDS" },
    ],
    warranty:
      "10-year product warranty with ≥6,000 cycles and ≥70% state-of-health retention, per the supplied Dyness Stack100 Pro (AU) warranty. The datasheet quotes a ≥8,000-cycle design life under beginning-of-life test conditions. Conditions apply — see the warranty document.",
    specNote:
      "Specifications are quoted from the official Dyness Stack100 Pro datasheet (v20260416, AU). Where the warranty document and datasheet differ (e.g. cycle life), both figures are shown and the warranty document governs. Exact supplied configuration is confirmed at quotation.",
  },
  {
    slug: "power-box-g2",
    name: "Powerbox G2",
    batteryId: "power-box-g2",
    category: "Battery system",
    manufacturer: "Dyness Powerbox G2",
    image: posterPowerboxFront,
    homeImage: posterPowerboxFront,
    imageAlt: "EI Battery — Dyness Powerbox G2 low-voltage LiFePO4 home battery",
    images: [posterPowerboxFront, posterPowerboxAngle, powerboxG2Cutaway, powerboxG2Exploded],
    video: { src: "/media/product-powerbox.mp4" },
    guideVideo: {
      src: "/media/powerbox-g2-connection-guide.mp4",
      label: "Connection guide",
      title: "Dyness Powerbox G2 connection guide with Solis S6",
      note: "Manufacturer connection walkthrough supplied by Dyness, shown with a Solis S6 hybrid inverter. Installation is carried out by your licensed electrical contractor.",
    },
    originalPrice: "$3,150",
    priceLabel: "$2,670",
    priceNote: "Dyness PowerBox G2 10.24 kWh kit launch price (was $3,150) — + GST, wholesale. Freight charged additionally where delivery is required.",
    hasPublicPrice: true,
    summary:
      "A slim, low-voltage LiFePO4 home battery that scales in parallel — a dependable storage block for your residential installations.",
    positioning:
      "A low-voltage (51.2 V) LiFePO4 residential battery with a slim 165 mm profile, wall- or floor-mounted, and scalable in parallel. Final configuration and pricing are confirmed at quotation.",
    kit: {
      note: "Supplied as a complete kit — battery, matched hybrid inverter and solar panels.",
      items: [
        "Dyness Powerbox G2 — low-voltage LiFePO4 battery",
        "Solis S6-EH3P(8–15)K02-NV-YD-L-AU hybrid inverter",
        "Risen 605–630 W solar panels",
      ],
      installer:
        "Roof mounting, PV/AC cable, isolation & protection, earthing, metering/CT and commissioning are sized and supplied by your installer for the site.",
    },
    highlights: [
      "Slim 6.5-inch (165 mm) design for flexible wall or floor mounting",
      "Scales in parallel — from 10.24 kWh up to 512 kWh",
      "1C discharge with a built-in aerosol fire extinguisher and IP66 rating",
    ],
    specs: [
      { label: "Battery chemistry", value: "Lithium iron phosphate (LiFePO4)" },
      { label: "Nominal energy (per unit)", value: "10.24 kWh (9.728 kWh usable)" },
      { label: "Nominal capacity", value: "200 Ah · 51.2 V" },
      { label: "Scalable (parallel)", value: "Up to 50 units — 10.24 to 512 kWh" },
      { label: "Discharge rate", value: "1C — max 10.24 kW continuous, 200 A" },
      { label: "Ingress protection", value: "IP66" },
      { label: "Communications", value: "CAN / RS485, built-in Wi-Fi, app OTA" },
      { label: "Temperature", value: "Operates to −20 °C with self-heating (optional)" },
      { label: "Dimensions / weight", value: "710 × 165 × 640 mm · approx. 99.7 kg" },
      { label: "Cycle life (datasheet)", value: "≥ 8,000 cycles / 10 years" },
    ],
    certifications: [],
    documents: [
      { label: "Dyness Powerbox G2 user manual (Sep 2026)", file: "/docs/dyness-powerbox-g2-usermanual-2026-09.pdf", type: "User manual" },
      { label: "Dyness Powerbox G2 datasheet (Aug 2025)", file: "/docs/dyness-powerbox-g2-datasheet-2025-08.pdf", type: "Datasheet" },
      { label: "Dyness Powerbox G2 warranty (AU, Jul 2024)", file: "/docs/dyness-powerbox-g2-warranty-au-2024-07.pdf", type: "Warranty" },
      { label: "Dyness Powerbox G2 safety data sheet (MSDS, Dec 2024)", file: "/docs/dyness-powerbox-g2-msds-2024-12.pdf", type: "MSDS" },
      { label: "Dyness Powerbox G2 UN38.3 test report (Jul 2024)", file: "/docs/dyness-powerbox-g2-un38-3-2024-07.pdf", type: "Compliance" },
      { label: "Dyness Powerbox G2 IEC 62619 certificate (Oct 2024)", file: "/docs/dyness-powerbox-g2-certificate-iec62619-2024-10.pdf", type: "Certificate" },
      { label: "Dyness Powerbox G2 IEC 62040 certificate (Nov 2024)", file: "/docs/dyness-powerbox-g2-certificate-iec62040-2024-11.pdf", type: "Certificate" },
      { label: "Dyness Powerbox G2 EMC certificate", file: "/docs/dyness-powerbox-g2-certificate-emc.pdf", type: "Certificate" },
      { label: "Dyness Powerbox G2 RED certificate", file: "/docs/dyness-powerbox-g2-certificate-red.pdf", type: "Certificate" },
    ],
    warranty:
      "10-year product warranty per the Dyness Powerbox G2 (AU) datasheet (≥8,000 cycles). Full warranty terms and conditions are confirmed with your quote.",
    specNote:
      "Specifications are quoted from the official Dyness Powerbox G2 datasheet (AU, v20250812). Exact supplied configuration and pricing are confirmed at quotation.",
  },
  {
    slug: "stack100-pro-bdu",
    name: "Stack100 Pro BDU",
    category: "Accessory",
    manufacturer: "Dyness",
    image: bduFrontPoster,
    imageAlt: "EI Battery Stack100 Pro BDU — battery distribution unit control panel",
    images: [bduFrontPoster, bduRearPoster, posterBdu],
    priceLabel: "$255",
    priceNote: "+ GST per unit (wholesale, ex GST). One BDU can service from 3 Stack 100 Pro batteries up to 15 Stack100 Pro batteries (15.36 kWh up to 76.80 kWh). Freight charged additionally where delivery is required.",
    hasPublicPrice: true,
    summary:
      "The battery distribution unit (BDU) for Dyness Stack100 Pro — One BDU can service from 3 Stack 100 Pro batteries up to 15 Stack100 Pro batteries (15.36 kWh up to 76.80 kWh).",
    positioning:
      "The Stack100 Pro BDU is the battery distribution unit that Stack100 Pro batteries connect to. One BDU can service from 3 Stack 100 Pro batteries up to 15 Stack100 Pro batteries (15.36 kWh up to 76.80 kWh).",
    highlights: [
      "Battery distribution unit for the Stack100 Pro range",
      "One BDU services up to 15 Stack100 Pro batteries (up to 76.8 kWh)",
      "Supplied wholesale to registered electrical contractors, builders and property developers",
    ],
    specs: [],
    certifications: [],
    documents: [],
    warranty:
      "Warranty terms are confirmed with your quote and handled through the registered electrical contractor.",
    specNote:
      "The BDU is the battery distribution unit for Dyness Stack100 Pro. Exact configuration is confirmed at quotation.",
  },
];

export const PROCESS = [
  { step: "01", title: "Submit a trade enquiry", body: "Tell us your business details, the products you need and quantities. You'll receive a unique reference immediately." },
  { step: "02", title: "Quotation prepared", body: "Our sales team checks trade eligibility, equipment, freight and commercial terms, then prepares your wholesale quote." },
  { step: "03", title: "Follow-up & approval", body: "We follow up your quotation by phone. Once approved, we advise when payment is required and confirm arrangements." },
  { step: "04", title: "Collection or delivery", body: "Collect from us or arrange Australia-wide delivery to your nominated site for an additional charge." },
];

export const FAQS = [
  { q: "Who can buy from EI Battery Solutions?", a: "We supply registered Australian electrical contractors, and builders and property developers approved by EI Battery for a trade account. Builders and developers must engage appropriately licensed electrical contractors and appropriately accredited installers for the work; a trade account does not authorise electrical work. We supply goods only and do not sell directly to residential end users." },
  { q: "Do EI Battery Solutions install the systems?", a: "No. EI Battery Solutions is supply-only. The contractor designs, installs, commissions and maintains each system. We supply the equipment and support your team." },
  { q: "How does warranty support work?", a: "Dyness provides the applicable manufacturer warranty for eligible Dyness products. EI Battery Solutions does not offer an additional voluntary supplier product warranty. End users usually contact their installer first; we then assist the trade customer and their installation contractor to lodge, document, follow up and work towards resolving the claim with Dyness. This does not guarantee manufacturer approval or a resolution date, and does not prevent anyone exercising rights that cannot be excluded under law. Warranty documents are available on each product page." },
  { q: "How long does delivery take?", a: "As a supplied estimate, delivery can be from same day to 7 days, depending on circumstances / destination of the order. Standard orders of up to 20 units can generally be fulfilled quickly, while multi-pallet or container orders may take five to six weeks as these are shipped in from our supplier. These are estimates subject to stock and order confirmation, not real-time availability." },
  { q: "What payment terms are available?", a: "Payment is required in full before dispatch, by the methods we offer for your order, which may include card payment, bank transfer or cash. We do not offer credit, finance or extended trading terms. We do not charge a card surcharge. Accepted payment methods and any deposit requirement are confirmed with your quotation." },
  { q: "Do you offer maintenance packages?", a: "No. Ongoing system maintenance is the installer's responsibility. We provide product and warranty support to the contractor." },
];

const SOLIS_DOCS = [
  { label: "Solis S6-EH3P(8–15)K hybrid inverter flyer (AU)", file: "/docs/solis-s6-eh3p-hybrid-inverter-flyer-au.pdf", type: "Datasheet" },
  { label: "Solis S6-EH3P(8–15)K inverter manual (AU)", file: "/docs/solis-s6-eh3p-inverter-manual.pdf", type: "User manual" },
  { label: "Solis S6-EH3P low-voltage hybrid manual (AU, supplied 19 Oct 2026)", file: "/docs/solis-s6-eh3p-lv-manual-au.pdf", type: "User manual" },
];
const SOLIS_PLUS_DOCS = [
  { label: "Solis S6-EH1P(3–8)K-L-PLUS-AU datasheet (AU, V1.6, May 2025)", file: "/docs/solis-s6-eh1p-3-8k-l-plus-au-datasheet.pdf", type: "Datasheet" },
];
const SOLIS_10K_DOCS = [
  { label: "Solis S6-EH1P(10–16)K03 hybrid inverter flyer (AU, V2.3)", file: "/docs/solis-s6-eh1p-10-16k03-au-flyer-v2-3.pdf", type: "Datasheet" },
];
const RISEN_DOCS = [
  { label: "Risen RSM132-11 610–635 W panel datasheet (AU, 2026H1)", file: "/docs/risen-rsm132-610-635w-panel-datasheet.pdf", type: "Datasheet" },
  { label: "Risen 25-year rooftop warranty (AU/NZ)", file: "/docs/risen-25-year-rooftop-warranty-au-nz.pdf", type: "Warranty" },
];

export const INVERTER_PRODUCTS = [
  {
    slug: "solis-s6-eh3p10k-h",
    phase: "three",
    component: true,
    name: "Solis S6-EH3P10K-H-AU",
    category: "10 kW three-phase high-voltage hybrid inverter",
    manufacturer: "Solis",
    image: invSolisHv3pFront,
    imageAlt: "Solis S6-EH3P10K-H-AU 10 kW three-phase high-voltage hybrid inverter",
    images: [invSolisHv3pFront, invSolisHv3pConnections, invSolisHv3pSide, invSolisHv3pRear],
    summary: "10 kW three-phase high-voltage hybrid inverter for Stack100 Pro three-phase systems.",
    positioning: "The high-voltage three-phase Solis hybrid matched to Dyness Stack100 Pro clusters. Exact model configuration and pricing are confirmed at quotation.",
    highlights: [
      "10 kW three-phase high-voltage hybrid inverter",
      "Pairs with Dyness Stack100 Pro three-phase battery clusters",
      "Supplied wholesale to registered electrical contractors, builders and property developers",
    ],
    specs: [
      { label: "Rated AC power", value: "10 kW" },
      { label: "Phase", value: "Three-phase" },
      { label: "Type", value: "High-voltage battery hybrid inverter" },
      { label: "Battery pairing", value: "Dyness Stack100 Pro (three-phase)" },
    ],
    certifications: [],
    documents: SOLIS_HV_3P_DOCS,
    priceLabel: "$2,230",
    priceNote: "Catalogue price — + GST per unit, wholesale ex GST. Freight charged additionally where delivery is required.",
    hasPublicPrice: true,
    warranty: "Manufacturer warranty per Solis terms, confirmed with your quote.",
    specNote: "Specifications summarised from the EI Battery catalogue (October 2026). Exact model configuration and pricing are confirmed at quotation.",
  },
  {
    slug: "solis-s6-eh3p15k-h",
    phase: "three",
    component: true,
    name: "Solis S6-EH3P15K-H-AU",
    category: "15 kW three-phase high-voltage hybrid inverter",
    manufacturer: "Solis",
    image: solis15kHvPhoto,
    imageAlt: "Solis S6-EH3P15K-H-AU 15 kW three-phase high-voltage hybrid inverter",
    images: [solis15kHvPhoto],
    summary: "15 kW three-phase high-voltage hybrid inverter for larger Stack100 Pro three-phase systems.",
    positioning: "The higher-output high-voltage three-phase Solis hybrid for larger Dyness Stack100 Pro clusters. Exact model configuration and pricing are confirmed at quotation.",
    highlights: [
      "15 kW three-phase high-voltage hybrid inverter",
      "Pairs with larger Dyness Stack100 Pro three-phase clusters",
      "Supplied wholesale to registered electrical contractors, builders and property developers",
    ],
    specs: [
      { label: "Rated AC power", value: "15 kW" },
      { label: "Phase", value: "Three-phase" },
      { label: "Type", value: "High-voltage battery hybrid inverter" },
      { label: "Battery pairing", value: "Dyness Stack100 Pro (three-phase)" },
    ],
    certifications: [],
    documents: [],
    priceLabel: "$2,920",
    priceNote: "Catalogue price — + GST per unit, wholesale ex GST. Freight charged additionally where delivery is required.",
    hasPublicPrice: true,
    warranty: "Manufacturer warranty per Solis terms, confirmed with your quote.",
    specNote: "Specifications summarised from the EI Battery catalogue (October 2026). Exact model configuration and pricing are confirmed at quotation.",
  },
  {
    slug: "solinteg-mhs-5k-30",
    phase: "single",
    name: "Solinteg MHS-5K-30",
    category: "5 kW single-phase high-voltage hybrid inverter",
    manufacturer: "Solinteg",
    image: invSolintegMhtFront,
    imageAlt: "Solinteg MHS-5K-30 5 kW single-phase hybrid inverter",
    images: [invSolintegMhtFront, invSolintegMhtAngle, invSolintegMhtConnections],
    summary: "5 kW single-phase high-voltage hybrid inverter for Stack100 Pro single-phase systems.",
    positioning: "Matched to Stack100 Pro single-phase battery stacks (BDU included). A compact 5 kW single-phase hybrid for smaller residential installs.",
    highlights: [
      "5 kW single-phase high-voltage hybrid inverter",
      "Pairs with Dyness Stack100 Pro single-phase battery stacks",
      "Supplied wholesale to registered electrical contractors, builders and property developers",
    ],
    specs: [
      { label: "Rated AC power", value: "5 kW" },
      { label: "Phase", value: "Single-phase" },
      { label: "Type", value: "High-voltage battery hybrid inverter" },
      { label: "Battery pairing", value: "Dyness Stack100 Pro (single-phase)" },
    ],
    certifications: [],
    documents: [],
    priceLabel: "$1,170",
    originalPrice: "$1,383",
    priceNote: "Launch price (was $1,383) — + GST per unit, wholesale ex GST. Freight charged additionally where delivery is required.",
    hasPublicPrice: true,
    warranty: "Manufacturer warranty per Solinteg terms, confirmed with your quote.",
    specNote: "Specifications summarised from the EI Battery launch catalogue (26 Sep 2026). Exact model configuration and pricing are confirmed at quotation.",
  },
  {
    slug: "solinteg-mhs-8k-30",
    phase: "single",
    name: "Solinteg MHS-8K-30",
    category: "8 kW single-phase high-voltage hybrid inverter",
    manufacturer: "Solinteg",
    image: invSolintegMhtFront,
    imageAlt: "Solinteg MHS-8K-30 8 kW single-phase hybrid inverter",
    images: [invSolintegMhtFront, invSolintegMhtAngle, invSolintegMhtConnections],
    summary: "8 kW single-phase high-voltage hybrid inverter for larger Stack100 Pro single-phase systems.",
    positioning: "A higher-output 8 kW single-phase hybrid for larger Stack100 Pro single-phase installs needing more AC headroom.",
    highlights: [
      "8 kW single-phase high-voltage hybrid inverter",
      "Pairs with larger Dyness Stack100 Pro single-phase stacks",
      "Supplied wholesale to registered electrical contractors, builders and property developers",
    ],
    specs: [
      { label: "Rated AC power", value: "8 kW" },
      { label: "Phase", value: "Single-phase" },
      { label: "Type", value: "High-voltage battery hybrid inverter" },
      { label: "Battery pairing", value: "Dyness Stack100 Pro (single-phase)" },
    ],
    certifications: [],
    documents: [],
    priceLabel: "$1,780",
    originalPrice: "$2,100",
    priceNote: "Launch price (was $2,100) — + GST per unit, wholesale ex GST. Freight charged additionally where delivery is required.",
    hasPublicPrice: true,
    warranty: "Manufacturer warranty per Solinteg terms, confirmed with your quote.",
    specNote: "Specifications summarised from the EI Battery launch catalogue (26 Sep 2026). Exact model configuration and pricing are confirmed at quotation.",
  },
  {
    slug: "solis-s6-eh3p10k",
    phase: "three",
    name: "Solis S6-EH3P10K02-NV-YD-L-AU",
    category: "Low-voltage hybrid inverter — for Powerbox G2",
    manufacturer: "Solis",
    image: invSolis3pFront,
    imageAlt: "Solis S6-EH3P10K 10 kW three-phase hybrid inverter",
    images: [invSolis3pFront, invSolis3pAngle, invSolis3pSide, invSolis3pConnections],
    summary: "10 kW three-phase low-voltage hybrid inverter (40–60 V battery input) for Powerbox G2 three-phase systems.",
    positioning: "A 10 kW three-phase low-voltage hybrid inverter used across PowerBox G2 three-phase packages.",
    highlights: [
      "10 kW three-phase hybrid inverter",
      "Built-in DC isolator and WiFi dongle included",
      "Low-voltage battery input (40–60 V) — pairs with PowerBox G2 three-phase",
      "Supplied wholesale to registered electrical contractors, builders and property developers",
    ],
    specs: [
      { label: "Rated AC power", value: "10 kW" },
      { label: "Phase", value: "Three-phase" },
      { label: "Type", value: "Low-voltage hybrid battery inverter" },
      { label: "Battery voltage range", value: "40–60 V" },
      { label: "Model", value: "S6-EH3P10K02-NV-YD-L-AU" },
    ],
    certifications: [],
    documents: SOLIS_DOCS,
    priceLabel: "$2,990",
    priceNote: "+ GST per unit, wholesale ex GST. Freight charged additionally where delivery is required.",
    hasPublicPrice: true,
    warranty: "Manufacturer warranty per Solis terms, confirmed with your quote.",
    specNote: "Specifications summarised from the EI Battery launch catalogue (26 Sep 2026). Inverter rating and compatibility are confirmed at quotation.",
  },
  {
    slug: "solis-s6-eh3p15k",
    phase: "three",
    name: "Solis S6-EH3P15K02-NV-YD-L-AU",
    category: "Low-voltage hybrid inverter — for Powerbox G2",
    manufacturer: "Solis",
    image: invSolis3pFront,
    imageAlt: "Solis S6-EH3P15K 15 kW three-phase hybrid inverter",
    images: [invSolis3pFront, invSolis3pAngle, invSolis3pSide, invSolis3pConnections],
    summary: "15 kW three-phase low-voltage hybrid inverter (40–60 V battery input) for larger Powerbox G2 three-phase systems.",
    positioning: "A 15 kW three-phase low-voltage hybrid inverter for larger PowerBox G2 three-phase packages.",
    highlights: [
      "15 kW three-phase hybrid inverter",
      "Built-in DC isolator and WiFi dongle included",
      "Low-voltage battery input (40–60 V) — pairs with larger PowerBox G2 three-phase systems",
      "Supplied wholesale to registered electrical contractors, builders and property developers",
    ],
    specs: [
      { label: "Rated AC power", value: "15 kW" },
      { label: "Phase", value: "Three-phase" },
      { label: "Type", value: "Low-voltage hybrid battery inverter" },
      { label: "Battery voltage range", value: "40–60 V" },
      { label: "Model", value: "S6-EH3P15K02-NV-YD-L-AU" },
    ],
    certifications: [],
    documents: SOLIS_DOCS,
    priceLabel: "$3,490",
    priceNote: "+ GST per unit, wholesale ex GST. Freight charged additionally where delivery is required.",
    hasPublicPrice: true,
    warranty: "Manufacturer warranty per Solis terms, confirmed with your quote.",
    specNote: "Specifications summarised from the EI Battery launch catalogue (26 Sep 2026). Inverter rating and compatibility are confirmed at quotation.",
  },
  {
    slug: "solis-s6-eh1p5k-plus",
    phase: "single",
    name: "Solis S6-EH1P5K-L-PLUS-AU",
    category: "Low-voltage hybrid inverter — single phase",
    manufacturer: "Solis",
    image: invSolisPlusFront,
    imageAlt: "Solis S6-EH1P5K-L-PLUS-AU 5 kW single-phase low-voltage hybrid inverter",
    images: [invSolisPlusFront, invSolisPlusAngle, invSolisPlusConnections, invSolisPlusSide],
    summary: "Ginlong/Solis S6 PLUS 5,000 W low-voltage hybrid inverter, single phase, built-in DC, WiFi included.",
    positioning: "A single-phase 5 kW low-voltage hybrid for PowerBox G2 and other 48 V battery systems, with the DC isolator built in.",
    highlights: [
      "5,000 W single-phase low-voltage hybrid inverter",
      "Built-in DC isolator and WiFi dongle included",
      "Low-voltage battery input (40–60 V) — pairs with PowerBox G2 single-phase",
      "Supplied wholesale to registered electrical contractors, builders and property developers",
    ],
    specs: [
      { label: "Rated AC power", value: "5 kW" },
      { label: "Phase", value: "Single-phase (1/N/PE)" },
      { label: "Type", value: "Low-voltage hybrid battery inverter" },
      { label: "Battery voltage range", value: "40–60 V" },
      { label: "Max PV input power", value: "10 kW (200% of rated AC output)" },
      { label: "MPPT / strings", value: "2 MPPTs, max 2 strings per MPPT" },
      { label: "MPPT voltage range", value: "90–435 V; 500 V max PV input" },
      { label: "Max charge / discharge current", value: "112 A" },
      { label: "W × H × D", value: "335 × 560 × 227 mm" },
      { label: "Weight", value: "22 kg" },
      { label: "Ingress protection", value: "IP66" },
      { label: "Communications", value: "RS485 / CAN; WiFi included" },
      { label: "Model", value: "S6-EH1P5K-L-PLUS-AU" },
    ],
    certifications: [],
    documents: SOLIS_PLUS_DOCS,
    priceLabel: "$1,530",
    priceNote: "+ GST per unit, wholesale ex GST. Freight charged additionally where delivery is required.",
    hasPublicPrice: true,
    warranty: "Manufacturer warranty per Solis terms, confirmed with your quote.",
    specNote: "Specifications taken from the Solis S6-EH1P(3–8)K-L-PLUS-AU datasheet (AU, V1.6, May 2025). Exact shipped revision and compatibility are confirmed at quotation.",
  },
  {
    slug: "solis-s6-eh1p10k-nv",
    phase: "single",
    name: "Solis S6-EH1P10K03-NV-YD-L",
    category: "Low-voltage hybrid inverter — single phase",
    manufacturer: "Solis",
    image: invSolis10kFront,
    imageAlt: "Solis S6-EH1P10K03-NV-YD-L 10 kW single-phase low-voltage hybrid inverter",
    images: [invSolis10kFront, invSolis10kAngle, invSolis10kSide, invSolis10kConnections],
    summary: "Ginlong/Solis S6 PLUS 10 kW low-voltage hybrid inverter, single phase, built-in DC, WiFi included.",
    positioning: "A 10 kW single-phase low-voltage hybrid for larger 48 V battery systems where three-phase supply is not available.",
    highlights: [
      "10 kW single-phase low-voltage hybrid inverter",
      "Built-in DC isolator and WiFi dongle included",
      "Low-voltage battery input — pairs with PowerBox G2 single-phase",
      "Supplied wholesale to registered electrical contractors, builders and property developers",
    ],
    specs: [
      { label: "Rated AC power", value: "9.999 kW" },
      { label: "Phase", value: "Single-phase" },
      { label: "Type", value: "Low-voltage hybrid battery inverter" },
      { label: "Battery voltage range", value: "40–60 V" },
      { label: "Max recommended PV array", value: "20 kW" },
      { label: "MPPT / strings", value: "3 MPPTs / 6 strings (2 per MPPT)" },
      { label: "MPPT voltage range", value: "100–450 V; 550 V max PV input" },
      { label: "Max charge / discharge current", value: "207 A" },
      { label: "W × H × D", value: "459 × 845 × 313 mm" },
      { label: "Weight", value: "55.5 kg" },
      { label: "Ingress protection", value: "IP66" },
      { label: "Communications", value: "WiFi + Bluetooth, CAN-BMS, CAN parallel ×2, RS485 meter, RS485, DRM; 4G/LAN optional" },
      { label: "Model", value: "S6-EH1P10K03-NV-YD-L" },
    ],
    certifications: [],
    documents: SOLIS_10K_DOCS,
    priceLabel: "$2,620",
    priceNote: "+ GST per unit, wholesale ex GST. Freight charged additionally where delivery is required.",
    hasPublicPrice: true,
    warranty: "Manufacturer warranty per Solis terms, confirmed with your quote.",
    specNote: "Specifications taken from the Solis S6-EH1P(10–16)K03-AU flyer (V2.3). Exact shipped revision and compatibility are confirmed at quotation.",
  },
];

export const PANEL_PRODUCTS = [
  {
    slug: "risen-630w-panel",
    name: "Risen 630 W solar panel",
    nameNote: "RSM132-11-630BNDG",
    category: "Solar panel",
    manufacturer: "Risen",
    image: panelRisen630Blue,
    imageAlt: "Risen RSM132-11-630BNDG 630 W solar panel",
    images: [panelRisen630Blue],
    summary: "High-efficiency N-type mono panel (605–630 W) with a 15-year product / 30-year performance warranty (manufacturer) — paired with every kit.",
    positioning: "Our standard high-output module, supplied across the Cygni, Stack100 Pro and PowerBox G2 kits.",
    highlights: [
      "630 W N-type monocrystalline module",
      "15-year product / 30-year performance warranty (manufacturer)",
      "Supplied with every battery + solar kit",
    ],
    specs: [
      { label: "Rated power", value: "630 W" },
      { label: "Cell technology", value: "N-type monocrystalline, dual-glass" },
      { label: "Model", value: "RSM132-11-630BNDG" },
    ],
    certifications: [],
    documents: RISEN_DOCS,
    priceLabel: "$145",
    originalPrice: "$189",
    priceNote: "Launch price (was $189) — + GST per panel, wholesale ex GST. Freight charged additionally where delivery is required.",
    hasPublicPrice: true,
    warranty: "15-year product / 30-year performance warranty (manufacturer). Manufacturer warranty applies. See each product's warranty document for its terms.",
    specNote: "Specifications summarised from the EI Battery launch catalogue (26 Sep 2026). Supplier SKU and pricing are confirmed at quotation.",
  },
  {
    slug: "risen-475w-panel",
    name: "Risen 475 Wp solar panel",
    nameNote: "RSM96-11-475BNDG",
    category: "Solar panel",
    manufacturer: "Risen",
    image: panelRisen475Blue,
    imageAlt: "Risen RSM96-11-475BNDG 475 W solar panel",
    images: [panelRisen475Blue],
    summary: "Compact 475 Wp N-type mono panel — ideal where roof space or layout calls for a smaller module.",
    positioning: "A smaller-format module for tighter roof layouts, supplied alongside our standard 630 W panel.",
    highlights: [
      "475 W N-type monocrystalline module",
      "Compact format for constrained roof layouts",
      "Supplied wholesale to registered electrical contractors, builders and property developers",
    ],
    specs: [
      { label: "Rated power", value: "475 W" },
      { label: "Cell technology", value: "N-type monocrystalline, dual-glass" },
      { label: "Model", value: "RSM96-11-475BNDG" },
    ],
    certifications: [],
    documents: RISEN_DOCS,
    priceLabel: "$125",
    originalPrice: "$163.88",
    priceNote: "Launch price (was $163.88) — + GST per panel, wholesale ex GST. Freight charged additionally where delivery is required.",
    hasPublicPrice: true,
    warranty: "Manufacturer warranty applies. See each product's warranty document for its terms.",
    specNote: "Specifications summarised from the EI Battery launch catalogue (26 Sep 2026). Supplier SKU and pricing are confirmed at quotation.",
  },
];
